var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatePrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3456 9.82908C19.3456 14.8105 15.3039 18.8535 10.3239 18.8535C5.34395 18.8535 2.30365 13.8359 2.30365 13.8359M2.30365 13.8359H6.38144M2.30365 13.8359V18.3481M1.30225 9.82908C1.30225 4.84761 5.30786 0.804688 10.3239 0.804688C16.3414 0.804688 19.3456 5.82225 19.3456 5.82225M19.3456 5.82225V1.31005M19.3456 5.82225H15.34",
    stroke: "#212529",
    strokeWidth: 1.35366,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatePrice);
export default __webpack_public_path__ + "static/media/update-price.233d806e1b0c29ddd46d117491284693.svg";
export { ForwardRef as ReactComponent };